import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './Components/header/header.component';
import { HomeComponent } from './Components/home/home.component';
import { DocumentComponent, DocumentExport } from './Components/document/document.component';
import { BrowserAnimationsModule, NoopAnimationsModule } from '@angular/platform-browser/animations';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatMenuModule } from '@angular/material/menu';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTableModule } from '@angular/material/table';
import { UserViewComponent } from './Components/user-view/user-view.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { MarketplaceComponent } from './Components/marketplace/marketplace.component';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { GalleryModule } from 'ng-gallery';
import { LightboxModule } from 'ng-gallery/lightbox';
import { ImageViewerModule } from '@hallysonh/ngx-imageviewer';
import { LoginComponent } from './Components/login/login.component';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
// import { MatListModule } from '@angular/material/list';
import { MatListModule } from '@angular/material/list'
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { GovtSchemeComponent } from './Components/govt-schemes/govt-schemes.component';
import { FertilizerRemainderComponent } from './Components/fertilizer-remainder/fertilizer-remainder.component';
import { MatNativeDateModule, MAT_DATE_LOCALE, NativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { IPublicClientApplication, PublicClientApplication, InteractionType } from '@azure/msal-browser';
import { MsalGuard, MsalBroadcastService, MsalModule, MsalService, MSAL_GUARD_CONFIG, MSAL_INSTANCE, MsalGuardConfiguration, MsalRedirectComponent } from '@azure/msal-angular';
import { NgxPaginationModule } from 'ngx-pagination';
import { msalConfig } from './auth-config';
import { ToastrModule } from 'ngx-toastr';
import { NgxSpinnerModule } from 'ngx-spinner';
import { DeletFertilizer, FertilizerDataExport, FertilizerlistComponent } from './Components/fertilizerlist/fertilizerlist.component';
import { InAppReviewComponent, InAppExportData } from './Components/in-app-review/in-app-review.component';
import { MatSortModule } from '@angular/material/sort';
import { CommonModule, DatePipe } from '@angular/common';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { TrackExportData, TrackYourHarvestComponent } from './track-your-harvest/track-your-harvest.component';
import { GovtSchemesExport, GovtSchemesListComponent, } from './Components/govt-schemes-list/govt-schemes-list.component';
import { MatChipsModule } from '@angular/material/chips';
import { MatTooltipModule } from '@angular/material/tooltip';
//import { BlogPageComponent } from './Components/blog-page/blog-page.component';
import { JwtInterceptor } from './helper/jwt.interceptor';
import { UserManagementService } from './Service/user-management.service';
import { AskAnExpertComponent, AskExportData } from './Components/ask-an-expert/ask-an-expert.component';
import { MarketExportData, MarketRateHistoricalDataComponent } from './Components/market-rate-historical-data/market-rate-historical-data.component';
import { UserProfileComponent } from './modals/user-profile/user-profile.component';
import { DeleteModalComponent } from './modals/delete-modal/delete-modal.component';
import { DeletPopUp } from './Components/govt-schemes-list/govt-schemes-list.component';
import { DeletePopUpManage } from './Components/govt-manage-schemes/govt-manage-schemes.component';
import { AddBlogsComponent } from './Components/add-blogs/add-blogs.component';
import { CKEditorModule } from 'ckeditor4-angular';
import { AddBlogsListComponent, DeletBlogPopup, ExportData } from './Components/add-blogs-list/add-blogs-list.component';
//import {DeletBlogPopup} from './Components/add-blogs-list/add-blogs-list.component';
import { MatDialogModule } from '@angular/material/dialog';
import { NewsHistoricalDataComponent } from './Components/news-historical-data/news-historical-data.component';
//import {ExportData} from './Components/add-blogs-list/add-blogs-list.component';
//import {MarketExportData} from './Components/market-rate-historical-data/market-rate-historical-data.component'
import { MatCheckboxModule } from '@angular/material/checkbox';
import { DeleteNewsRow } from './Components/news-historical-data/news-historical-data.component';
import { NewsExportData } from './Components/news-historical-data/news-historical-data.component'
import { UserExportData } from './Components/user-view/user-view.component'
import { AddNewsComponent } from './Components/add-news/add-news.component';
import { SureveyDataComponent, SureveyExportData, SureveyDeletePopup } from './Components/surevey-data/surevey-data.component';
import { SureveyConductComponent } from './Components/surevey-conduct/surevey-conduct.component';
// import { SureveyConductComponent } from './components/surevey-conduct/surevey-conduct.component';
import { AccessControlComponent } from './Components/access-control/access-control.component';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { GovtManageSchemesComponent } from './Components/govt-manage-schemes/govt-manage-schemes.component';
import { addValue, priceValue, productExportData, ProductListComponent } from './Components/product-list/product-list.component';
import { RemarkPopupComponent } from './modals/remark-popup/remark-popup.component';
import { TicketDetail } from './Components/ask-an-expert/ask-an-expert.component';
import { TransactionExport, TransactionListComponent, transactionPrice, transactionQuantity } from './Components/transaction-list/transaction-list.component';
import { DocumentHistoryComponent } from './Components/document-history/document-history.component';
import { ViewDetailComponent } from './modals/view-detail/view-detail.component';
import { SettingComponent } from './Components/setting/setting.component';
import { SettingDeletePopup } from './Components/setting/setting.component';
import { SessionExpireComponent } from './Components/session-expire/session-expire.component';
import { UnauthorizedPageComponent } from './Components/unauthorized-page/unauthorized-page.component';
import { InterceptorService } from './interceptor.service';
import { SFDateComponent } from './modals/sf-date/sf-date.component';
import { MatRadioModule } from '@angular/material/radio';
import { DiscussionBoardComponent, DiscussionBoardExportData } from './Components/discussion-board/discussion-board.component';
import { DiscussionBoardAskPageComponent } from './Components/discussion-board-ask-page/discussion-board-ask-page.component';
import { CloseQuestionpopup, DiscussionBoardDetailsComponent, PutBackpopup, Removepopup } from './Components/discussion-board-details/discussion-board-details.component';
import { DiscussionboardGuidelinesComponent } from './Components/discussionboard-guidelines/discussionboard-guidelines.component';
import { BannerManagementComponent } from './Components/banner-management/banner-management.component';
import { DeleteVideoData, VideoExportData, VideoLibraryComponent, } from './Components/video-library/video-library.component';
import { PostAVideoComponent } from './Components/post-a-video/post-a-video.component';
import { DeleteCategoryPopup, VideoCategoryManageComponent } from './Components/video-category-manage/video-category-manage.component';
import { DeleteManageMarket, ManageMarketComponent } from './Components/manage-market/manage-market.component';
import { DeleteManageCrop, ManageCropComponent } from './Components/manage-crop/manage-crop.component';
import { DeleteManageUnit, ManageUnitComponent } from './Components/manage-unit/manage-unit.component';
import { ManageProductComponent } from './Components/manage-product/manage-product.component';
import { ManageSubProductComponent } from './Components/manage-sub-product/manage-sub-product.component';
import { DeleteProductComponent } from './Components/manage-product/delete-product/delete-product.component';
import { DeleteSubProductComponent } from './Components/manage-sub-product/delete-sub-product/delete-sub-product.component';
import { BlogManageCategoryComponent, DeleteBlogCategory } from './Components/blog-manage-category/blog-manage-category.component';
import { HarvestCropComponent } from './track-your-harvest/harvest-crop/harvest-crop.component';
import { HarvestUnitComponent } from './track-your-harvest/harvest-unit/harvest-unit.component';
import { AddHarvestCropComponent } from './track-your-harvest/add-harvest-crop/add-harvest-crop.component';
import { DeleteHarvestCropComponent } from './track-your-harvest/delete-harvest-crop/delete-harvest-crop.component';
import { DeleteHarvestUnitComponent } from './track-your-harvest/delete-harvest-unit/delete-harvest-unit.component';
import { DominateMarketComponent } from './Components/dominate-market/dominate-market.component';
//import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';

// import { MsalInterceptor, MsalModule, MsalService, MSAL_INSTANCE } from '@azure/msal-angular';
// import { IPublicClientApplication, PublicClientApplication } from '@azure/msal-browser';

// import { MsalUserService } from './Service/msaluser.service';
/**
 * Here we pass the configuration parameters to create an MSAL instance.
 * For more info, visit: https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-angular/docs/v2-docs/configuration.md
 */
export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication(msalConfig);
}
/**
 * Set your default interaction type for MSALGuard here. If you have any
 * additional scopes you want the user to consent upon login, add them here as well.
 */
export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
  };
}

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    HomeComponent,
    DocumentComponent,
    DeletPopUp,
    DeletePopUpManage,
    SettingDeletePopup,
    TicketDetail,
    SettingDeletePopup,
    DeletBlogPopup,
    ExportData,
    MarketExportData,
    DeleteNewsRow,
    NewsExportData,
    LoginComponent, UserViewComponent, MarketplaceComponent,
    GovtSchemeComponent, FertilizerRemainderComponent,
    FertilizerlistComponent, InAppReviewComponent, TrackYourHarvestComponent,
    GovtSchemesListComponent, MarketRateHistoricalDataComponent,
    UserProfileComponent, AddBlogsComponent, AddBlogsListComponent,
    MarketplaceComponent,
    GovtSchemeComponent,
    FertilizerRemainderComponent,
    FertilizerlistComponent,
    InAppReviewComponent,
    InAppExportData,
    TrackYourHarvestComponent,
    TrackExportData,
    GovtSchemesListComponent,
    AskAnExpertComponent,
    AskExportData,
    MarketRateHistoricalDataComponent,
    DeleteModalComponent,
    NewsHistoricalDataComponent,
    SureveyDataComponent,
    SureveyExportData,
    SureveyDeletePopup,
    AddNewsComponent,
    UserExportData,
    DocumentExport,
    SureveyConductComponent,
    GovtSchemesExport,
    FertilizerDataExport,
    DeletFertilizer,
    GovtManageSchemesComponent,
    AccessControlComponent,
    productExportData,
    addValue,
    priceValue,
    ProductListComponent,
    RemarkPopupComponent,
    TransactionListComponent,
    TransactionExport,
    transactionPrice,
    transactionQuantity,
    ViewDetailComponent,
    SettingComponent,
    DocumentHistoryComponent,
    SessionExpireComponent,
    UnauthorizedPageComponent,
    SFDateComponent,
    DiscussionBoardComponent,
    DiscussionBoardAskPageComponent,
    DiscussionBoardDetailsComponent,
    DiscussionboardGuidelinesComponent,
    DiscussionBoardExportData,
    CloseQuestionpopup,
    PutBackpopup,
    Removepopup,
    BannerManagementComponent,
    VideoLibraryComponent,
    PostAVideoComponent,
    VideoExportData,
    DeleteVideoData,
    VideoCategoryManageComponent,
    DeleteCategoryPopup,
    ManageMarketComponent,
    ManageCropComponent,
    ManageUnitComponent,
    DeleteManageMarket,
    DeleteManageCrop,
    DeleteManageUnit,
    ManageProductComponent,
    ManageSubProductComponent,
    DeleteProductComponent,
    DeleteSubProductComponent,
    BlogManageCategoryComponent,
    DeleteBlogCategory,
    AddHarvestCropComponent,
    HarvestCropComponent,
    HarvestUnitComponent,
    DeleteHarvestCropComponent,
    DeleteHarvestUnitComponent,
    DominateMarketComponent,
  ],

  imports: [
    MatDatepickerModule, NativeDateModule, MatNativeDateModule, ToastrModule.forRoot(), BrowserAnimationsModule,
    NgxDocViewerModule, NgxPaginationModule,
    HttpClientModule, NgxSpinnerModule,
    BrowserModule,
    AppRoutingModule,
    GalleryModule,
    LightboxModule,
    CKEditorModule,
    ImageViewerModule,
    //*MATERIAL IMPORTS
    MatSidenavModule,
    MatToolbarModule,
    MatMenuModule,
    MatIconModule,
    MatDividerModule,
    // MatListModule,
    MatInputModule,
    MsalModule,
    MatRadioModule,
    MatTableModule,
    MatPaginatorModule,
    MatPaginatorModule,
    MatAutocompleteModule,
    NoopAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    MatCardModule,
    MatSelectModule,
    MatInputModule,
    MatButtonModule,
    MatSortModule,
    PdfViewerModule,
    MatChipsModule,
    MatTooltipModule,
    MatDialogModule,
    MatCheckboxModule,
    NgxMatSelectSearchModule,
    CommonModule,
    MatListModule,
    MatFormFieldModule,
    NgxDaterangepickerMd.forRoot({
      separator: ' - ',
      applyLabel: 'Okay',
      cancelLabel: 'Cancel'

    }),

  ],


  providers: [
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory
    },

    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptorService,
      multi: true
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
    DatePipe,
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true, deps: [UserManagementService] },
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }
  ],
  entryComponents: [DeletPopUp, DeletePopUpManage, SettingDeletePopup, DeletBlogPopup, ExportData, MarketExportData, SureveyExportData, TrackExportData, InAppExportData, DeleteNewsRow, NewsExportData, UserExportData, DocumentExport, GovtSchemesExport, FertilizerDataExport, DeletFertilizer, productExportData, addValue, priceValue, TransactionExport, transactionPrice, transactionQuantity, DiscussionBoardExportData, CloseQuestionpopup, PutBackpopup, Removepopup],
  bootstrap: [AppComponent],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA
  ],
})
export class AppModule { }
